import { EventEmitter } from '@angular/core'

import { UiExceptionHandler } from './ui-exception-handler'
import { DialogConfiguration } from '../../angular/components/dialog'
import { RedirectHelper, DomUtils } from '../../helpers'
import { TokenExpiredError } from '../../models'

export class TokenExpiredExceptionHandler extends UiExceptionHandler {

  constructor(
    private _redirectHelper: RedirectHelper,
    domUtils: DomUtils
  ) {
    super(domUtils)
  }

  public handledErrors() {
    return [TokenExpiredError]
  }

  protected _dialogConfigurations(): DialogConfiguration {
   return {
      title: 'Session Expired',
      message: `<p>Your session has expired. Please click OK to login again.</p>`,
      dismissable: false,
      buttons: [
        {
          title: 'OK',
          emitter: this._confirmEmitter
        }
      ]
    }
  }

  protected onConfirm() {
    this._redirectHelper.toLoginPage()
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/helpers/exception-handlers/token-expired-exception-handler.ts